import React, { FC } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { iRootState } from '../../../store';
import { paths } from '../../Root/paths';

import AreaListItem from './AreaListItem';

const mapState = (state: iRootState) => ({
  map: state.infrastructureMap.map,
  layers: state.infrastructureMap.layers,
  alertArea: state.infrastructureAreas.alert
});

type connectedProps = ReturnType<typeof mapState>;

type IProps = connectedProps;

interface IAreaParams {
  id: string;
}

const AreaMarkerList: FC<IProps> = ({ map, layers, alertArea }) => {
  const { areas } = map;
  const { isAreas, onlyWorkingAreas } = layers;

  const areaEditMatch = useRouteMatch<IAreaParams>(paths.map.office.areas.edit());

  const areaParamId = areaEditMatch ? areaEditMatch.params.id : null;
  const baseList = onlyWorkingAreas ? areas.filter(area => area.appliance === 'GENERIC') : areas;
  let areaList = areaParamId ? baseList.filter(item => String(item.id) !== String(areaParamId)) : baseList;

  // Зона из критического уведомления не подчиняется фильтрам слоёв,
  // иначе подсветка может остаться на скрытом слое
  const alertId = alertArea ? String(alertArea.id) : null;
  const alertZone =
    alertId && (areaParamId === null || alertId !== String(areaParamId))
      ? areas.find(area => String(area.id) === alertId)
      : null;

  if (alertZone && !areaList.some(area => String(area.id) === alertId)) {
    areaList = [...areaList, alertZone];
  }

  const visibleList = isAreas ? areaList : alertZone ? [alertZone] : [];

  return <>{visibleList.map(area => <AreaListItem key={area.id} area={area} />)}</>;
};

const withConnect = connect(mapState);

export default withConnect(AreaMarkerList);
